import { useState } from 'react';
import Modal from '@mui/material/Modal';
import { Button } from '@upmc/ims.component-library';
import styles from './NotificationRecipientsUpdate.module.scss';
import Base from '../../../../Base/Base';
import classNames from 'classnames';
import Radio from '../../../../../components/UI/MDC/Radio/Radio';

//param- notificationEvent : NotificationEvent
//param- notificationDescription : string
const NotificationRecipientsUpdate = ({
	notificationEvent,
	notificationDescription,
	setAppNotifications,
	appNotifications,
	notificationType,
	disabled,
	requirementNumber,
}) => {
	const INPUT_TYPES = {
		DISTRIBUTION_GROUP: 'distribution group',
		INDIVIDUAL_RECIPIENTS: 'individual recipients',
	};
	const [modalOpen, setModalOpen] = useState(false);
	const [inputType, setInputType] = useState(INPUT_TYPES.DISTRIBUTION_GROUP);

	const conditionallyRenderInputComponent = () => {
		switch (inputType) {
			case INPUT_TYPES.DISTRIBUTION_GROUP:
				return DistributionGroupInput();
			case INPUT_TYPES.INDIVIDUAL_RECIPIENTS:
				//TODO: Implement component to allow users to select recipients from the eso table
				return <p>Feature In Development</p>;
			default:
				return <p>input type not selected</p>;
		}
	};

	//Distribution Group Input
	const DistributionGroupInput = () => {
		return (
			<>
				<label for='DistributionGroup_input'>
					{/* //TODO: modify label after implementing individual recipient select component  to indicate that this is for inputing distribution group address */}
					Manual Input(
					{notificationEvent?.recipients?.length || 0}/128)
				</label>{' '}
				<p className={styles.sub_label}>
					Format Multiple Recipients as a semicolon (;) delimited list
					(i.e RecipientOne@UPMC.edu;RecipientTwo@UPMC.edu)
				</p>
				<input
					name='DistributionGroup_Input'
					id='DistributionGroup_Input'
					type='text'
					maxLength={128}
					value={notificationEvent?.recipients}
					className={styles.text_input}
					onChange={e => handleChange(e)}
				/>
			</>
		);
	};

	const handleChange = e => {
		let currentAppNotifications = [...appNotifications];
		let selectedNotification = currentAppNotifications.find(
			notification => {
				return (
					notification.actionID === notificationType.actionID &&
					notification.eventTypeID === notificationType.eventTypeID
				);
			}
		);

		selectedNotification.recipients = e.target.value;

		setAppNotifications(currentAppNotifications);
	};

	return (
		<div>
			<Button
				id='notification_recipients_edit_btn'
				onClick={() => setModalOpen(true)}
				disabled={disabled}
			>
				Edit Recipients
			</Button>
			<Modal open={modalOpen} onClose={() => setModalOpen(false)}>
				<div className={styles.Modal}>
					<Base title='Update Notification Recipients'>
						<div
							className={classNames([
								styles.SubTitle,
								styles.flex_center,
							])}
						>
							<h3>{notificationDescription}</h3>
						</div>
						<div className={styles.flex_center}>
							<label
								for='DistributionGroup'
								className={styles.margin_none}
							>
								{/* Distribution Group{' '} */}
								Manual Input
							</label>
							<Radio
								name='DistributionGroup'
								id='distributionGroup_radio'
								value={INPUT_TYPES.DISTRIBUTION_GROUP}
								checked={
									inputType === INPUT_TYPES.DISTRIBUTION_GROUP
								}
								onClick={() =>
									setInputType(INPUT_TYPES.DISTRIBUTION_GROUP)
								}
							/>
						</div>
						<div className={styles.flex_center}>
							<Button
								onClick={() => {
									setModalOpen(false);
								}}
								id='notificationRecipientsUpdate_done'
							>
								Done
							</Button>
						</div>

						<hr></hr>
						{/* Render Distribution Group component or individual recipient selection component based on input type selection */}
						{conditionallyRenderInputComponent()}
					</Base>
				</div>
			</Modal>
		</div>
	);
};

export default NotificationRecipientsUpdate;
